import { ProjectDataflowLogModel } from '../../../services/ProjectService';
import { t } from 'i18next';
import moment from 'moment';
import { Trans } from 'react-i18next';
import { ColumnCustomProps } from '../../../components/DataGridCustom';
import DataGridCustomCS from '../../../components/DataGridCustomCS';
import { Icon } from '@progress/kendo-react-common';
export function LogsComponent({ logs }: { logs: ProjectDataflowLogModel[]; }) {
  const renderSeverityIcon = (props: any) => {
    const severity = props.dataItem.Severity;
    let iconName = '';
    let color = '';

    switch (severity) {
      case 'Critical':
      case 'Error':
        iconName = 'warning-triangle';
        color = 'red';
        break;
      case 'Warning':
        iconName = 'warning-circle';
        color = 'orange';
        break;
      case 'Info':
        iconName = 'info';
        color = 'blue';
        break;
      default:
        iconName = 'question-mark-circle';
        color = 'gray';
        break;
    }

    return (
      <td style={{ color, textAlign: 'center' }}>
        <Icon name={iconName} style={{ color, width: '20px', height: '20px' }} />
    </td>
    );
  };
  const columns: ColumnCustomProps[] = [
    {
      field: 'Severity', 
      title: t("configuration.projects.severity"),
      isExportable: true, 
      filterable: false, // Disable filtering for this column
      cell: renderSeverityIcon, // Use the custom cell renderer
      width: '100px',
    },
    {
      field: 'CreationDate', 
      title: t("configuration.projects.createdOn"), 
      filter: "date",
      filterable: false,
      cell: (props) => (
        <td>
          {moment(props.dataItem["CreationDate"]).format('HH:mm:ss.SSS')}
        </td>
      ),
      width: '200px',
      isExportable: true, 
    },
    {
      field: 'Message',
      title: t("configuration.projects.message"), 
      isExportable: true,
    },
  ]; 

  return (
    <>
      <div>
      <strong><Trans>configuration.projects.messages</Trans>:</strong>
      </div>
      <DataGridCustomCS
        ShowRemoveButton={false}
        ShowExportButton={false}
        dataSource={[...logs].sort((a, b) => new Date(b.CreationDate).getTime() - new Date(a.CreationDate).getTime())} // Sort logs by CreationDate descending
        DataItemKey="Id"
        Columns={columns} 
        ShowAddButton={false}
        ShowCustomButton={false}
        PageSize={15}
      />
    </>
  );
}
